(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-luma-scratch]';
  var SEEN_KEY = 'lumaauraScratchSeenAt';
  var TAG_REVEALED_KEY = 'lumaauraScratchTagRevealed';
  var DAY_MS = 86400000;

  function query(selector, root) {
    return (root || document).querySelector(selector);
  }

  function animateAndRemove(element, keyframes, options) {
    if (!element) return;
    if (typeof element.animate === 'function') {
      var animation = element.animate(keyframes, options);
      animation.onfinish = function () { element.remove(); };
    } else {
      window.setTimeout(function () { element.remove(); }, (options.delay || 0) + (options.duration || 0));
    }
  }

  function boot() {
    var root = query(ROOT_SELECTOR);
    if (!root || root.getAttribute('data-luma-scratch-ready') === 'true') return;
    root.setAttribute('data-luma-scratch-ready', 'true');

    var desktop = window.matchMedia('(min-width: 1024px)');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var days = parseInt(root.getAttribute('data-frequency-days') || '5', 10);
    var delay = parseInt(root.getAttribute('data-delay') || '2', 10);
    var useExitIntent = root.getAttribute('data-exit-intent') === 'true';
    var brand = (root.getAttribute('data-brand') || 'LUMAAURA').toUpperCase();

    var canvas = query('[data-luma-scratch-canvas]', root);
    var tag = query('[data-luma-scratch-tag]');
    var tagCanvas = tag ? query('.luma-scratch-tag__foil', tag) : null;
    var hintCovered = query('[data-luma-scratch-hint-covered]', root);
    var hintRevealed = query('[data-luma-scratch-hint-revealed]', root);
    var dragHint = query('[data-luma-scratch-drag]', root);
    var defaultState = query('[data-luma-scratch-default]', root);
    var successState = query('[data-luma-scratch-success]', root);
    var form = query('.luma-scratch__form', root);
    var postedSuccess = query('[data-luma-scratch-posted-success]', root);
    var formError = query('[data-luma-scratch-form-error]', root);
    var codeButton = query('[data-luma-scratch-code]', root);

    var painted = false;
    var revealed = false;
    var drawing = false;
    var eraseCount = 0;
    var lastPoint = null;
    var autoOpened = false;
    var previousFocus = null;
    var lockState = null;
    var flakeLayer = null;
    var celebrated = false;

    function storageGet(key) {
      try { return window.localStorage.getItem(key); } catch (error) { return null; }
    }

    function storageSet(key, value) {
      try { window.localStorage.setItem(key, value); } catch (error) {}
    }

    function wasSeenRecently() {
      var value = parseInt(storageGet(SEEN_KEY) || '0', 10);
      return value > 0 && Date.now() - value < days * DAY_MS;
    }

    function markSeen() {
      storageSet(SEEN_KEY, String(Date.now()));
    }

    function tagWasRevealed() {
      return storageGet(TAG_REVEALED_KEY) === '1';
    }

    function markTagRevealed() {
      storageSet(TAG_REVEALED_KEY, '1');
      if (tag) tag.classList.add('is-revealed');
    }

    function lockPage() {
      if (lockState) return;
      var body = document.body;
      var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      lockState = {
        scrollY: scrollY,
        position: body.style.position,
        top: body.style.top,
        left: body.style.left,
        right: body.style.right,
        width: body.style.width,
        overflow: body.style.overflow,
        touchAction: body.style.touchAction
      };
      body.style.position = 'fixed';
      body.style.top = '-' + scrollY + 'px';
      body.style.left = '0';
      body.style.right = '0';
      body.style.width = '100%';
      body.style.overflow = 'hidden';
      body.style.touchAction = 'none';
      body.classList.add('luma-scratch-open');
    }

    function unlockPage() {
      if (!lockState) return;
      var body = document.body;
      var saved = lockState;
      lockState = null;
      body.style.position = saved.position;
      body.style.top = saved.top;
      body.style.left = saved.left;
      body.style.right = saved.right;
      body.style.width = saved.width;
      body.style.overflow = saved.overflow;
      body.style.touchAction = saved.touchAction;
      body.classList.remove('luma-scratch-open');
      window.scrollTo(0, saved.scrollY);
    }

    function darkFoil(context, width, height) {
      context.fillStyle = '#2d2d2d';
      context.fillRect(0, 0, width, height);
      context.strokeStyle = 'rgba(255,255,255,0.055)';
      context.lineWidth = 10;
      for (var x = -height; x < width + height; x += 26) {
        context.beginPath();
        context.moveTo(x, 0);
        context.lineTo(x + height, height);
        context.stroke();
      }
      context.strokeStyle = 'rgba(255,255,255,0.18)';
      context.lineWidth = 1;
      context.strokeRect(6.5, 6.5, width - 13, height - 13);
      context.fillStyle = 'rgba(250,250,249,0.92)';
      context.font = '700 11px Lato, sans-serif';
      context.textAlign = 'center';
      context.textBaseline = 'middle';
      context.fillText('S C R A T C H   H E R E', width / 2, height / 2 - 8);
      context.font = '300 9px Lato, sans-serif';
      context.fillStyle = 'rgba(250,250,249,0.55)';
      context.fillText('your welcome gift is underneath', width / 2, height / 2 + 12);
    }

    function goldFoil(context, width, height, fontSize) {
      context.globalCompositeOperation = 'source-over';
      var gradient = context.createLinearGradient(0, 0, width, height);
      gradient.addColorStop(0, '#d9c79e');
      gradient.addColorStop(0.35, '#c9b694');
      gradient.addColorStop(0.55, '#e3d3ac');
      gradient.addColorStop(0.8, '#c2ad87');
      gradient.addColorStop(1, '#d5c29a');
      context.fillStyle = gradient;
      context.fillRect(0, 0, width, height);
      context.fillStyle = 'rgba(120,98,62,0.5)';
      context.font = '700 ' + fontSize + 'px Lato, sans-serif';
      context.textAlign = 'left';
      context.textBaseline = 'middle';
      var word = brand + ' · SCRATCH TO REVEAL · ';
      var wordWidth = Math.max(context.measureText(word).width, 1);
      context.save();
      context.rotate(-0.06);
      for (var row = 0, y = -height * 0.2; y < height * 1.4; y += fontSize * 2.2, row += 1) {
        for (var x = -wordWidth + (row % 2) * (wordWidth / 2) - width * 0.2; x < width * 1.3; x += wordWidth) {
          context.fillText(word, x, y);
        }
      }
      context.restore();
    }

    function paintFoil(attempt) {
      if (!canvas || revealed) return;
      var rect = canvas.getBoundingClientRect();
      if (!rect.width || !rect.height) {
        if ((attempt || 0) < 30) {
          window.requestAnimationFrame(function () { paintFoil((attempt || 0) + 1); });
        }
        return;
      }
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.round(rect.width * dpr);
      canvas.height = Math.round(rect.height * dpr);
      var context = canvas.getContext('2d');
      context.setTransform(dpr, 0, 0, dpr, 0, 0);
      context.clearRect(0, 0, rect.width, rect.height);
      if (desktop.matches) goldFoil(context, rect.width, rect.height, 11);
      else darkFoil(context, rect.width, rect.height);
      canvas.style.transition = '';
      canvas.style.opacity = '1';
      canvas.style.pointerEvents = 'auto';
      painted = true;
    }

    function popStamp(context, x, y, radius) {
      var gradient = context.createRadialGradient(x, y, radius * 0.52, x, y, radius);
      gradient.addColorStop(0, 'rgba(0,0,0,1)');
      gradient.addColorStop(0.82, 'rgba(0,0,0,0.9)');
      gradient.addColorStop(1, 'rgba(0,0,0,0)');
      context.fillStyle = gradient;
      context.beginPath();
      context.arc(x, y, radius, 0, Math.PI * 2);
      context.fill();
      for (var i = 0; i < 6; i += 1) {
        var angle = Math.random() * Math.PI * 2;
        var distance = radius * (0.5 + Math.random() * 0.65);
        var crumbRadius = radius * (0.12 + Math.random() * 0.28);
        context.fillStyle = 'rgba(0,0,0,' + (0.45 + Math.random() * 0.55) + ')';
        context.beginPath();
        context.arc(x + Math.cos(angle) * distance, y + Math.sin(angle) * distance, crumbRadius, 0, Math.PI * 2);
        context.fill();
      }
    }

    function getFlakeLayer() {
      if (flakeLayer && flakeLayer.parentNode) return flakeLayer;
      var host = query('.luma-scratch__scratch-card', root);
      if (!host) return null;
      flakeLayer = document.createElement('span');
      flakeLayer.setAttribute('aria-hidden', 'true');
      flakeLayer.style.cssText = 'position:absolute;inset:0;z-index:7;pointer-events:none;overflow:visible;';
      host.appendChild(flakeLayer);
      return flakeLayer;
    }

    function addFlakes(x, y) {
      if (!desktop.matches || reduceMotion.matches) return;
      var layer = getFlakeLayer();
      if (!layer) return;
      var count = 1 + (Math.random() < 0.6 ? 1 : 0);
      var palette = ['#d8c6a2', '#c4af88', '#e6d9be', '#b69c6f'];
      for (var i = 0; i < count; i += 1) {
        var flake = document.createElement('span');
        var width = 2 + Math.random() * 3.2;
        var height = 4 + Math.random() * 6;
        var color = palette[(Math.random() * palette.length) | 0];
        flake.style.cssText = 'position:absolute;left:' + (x - width / 2) + 'px;top:' + (y - height / 2) + 'px;width:' + width + 'px;height:' + height + 'px;background:linear-gradient(155deg,' + color + ',rgba(120,96,52,0.35));border-radius:2px;box-shadow:0 1px 1px rgba(0,0,0,0.18);';
        layer.appendChild(flake);
        var dx = (Math.random() - 0.5) * 50;
        var dy = 24 + Math.random() * 48;
        var rotation = (Math.random() - 0.5) * 340;
        animateAndRemove(flake, [
          { transform: 'translate(0,0) rotate(0)', opacity: 1 },
          { transform: 'translate(' + dx + 'px,' + dy + 'px) rotate(' + rotation + 'deg)', opacity: 0 }
        ], { duration: 480 + Math.random() * 280, easing: 'cubic-bezier(0.3,0.7,0.4,1)' });
      }
    }

    function celebrate() {
      if (!desktop.matches || reduceMotion.matches || celebrated) return;
      var layer = getFlakeLayer();
      if (!layer) return;
      celebrated = true;
      window.setTimeout(function () { celebrated = false; }, 1500);
      var rect = canvas ? canvas.getBoundingClientRect() : { width: 400, height: 250 };
      var width = rect.width || 400;
      var height = rect.height || 250;

      var burst = document.createElement('span');
      burst.style.cssText = 'position:absolute;left:' + (width / 2) + 'px;top:' + (height / 2) + 'px;width:36px;height:36px;margin:-18px 0 0 -18px;border-radius:50%;background:radial-gradient(circle,rgba(255,255,255,0.55),rgba(255,255,255,0) 70%);';
      layer.appendChild(burst);
      animateAndRemove(burst, [
        { transform: 'scale(0.4)', opacity: 1 },
        { transform: 'scale(4)', opacity: 0 }
      ], { duration: 650, easing: 'cubic-bezier(0.15,0.7,0.3,1)' });

      var colors = ['#c9b694', '#fbfbfb', '#2d2d2d', '#b08d57'];
      for (var i = 0; i < 38; i += 1) {
        var piece = document.createElement('span');
        var pieceWidth = 4 + Math.random() * 5;
        var pieceHeight = 7 + Math.random() * 9;
        piece.style.cssText = 'position:absolute;left:' + (width / 2) + 'px;top:' + (height / 2) + 'px;width:' + pieceWidth + 'px;height:' + pieceHeight + 'px;background:' + colors[i % colors.length] + ';border-radius:1px;box-shadow:0 1px 2px rgba(0,0,0,0.15);';
        layer.appendChild(piece);
        var angle = Math.random() * Math.PI * 2;
        var distance = 70 + Math.random() * 150;
        var dx = Math.cos(angle) * distance;
        var dy = Math.sin(angle) * distance - 30 + Math.random() * 100;
        var rotation = (Math.random() - 0.5) * 700;
        animateAndRemove(piece, [
          { transform: 'translate(-50%,-50%) rotate(0)', opacity: 1 },
          { transform: 'translate(calc(-50% + ' + dx + 'px),calc(-50% + ' + dy + 'px)) rotate(' + rotation + 'deg)', opacity: 0 }
        ], { duration: 800 + Math.random() * 440, easing: 'cubic-bezier(0.15,0.7,0.3,1)' });
      }

      var offer = query('.luma-scratch__offer', root);
      if (offer) {
        var match = (offer.textContent || '').match(/^(\d+)%([\s\S]*)$/);
        if (match) {
          var target = parseInt(match[1], 10);
          var suffix = match[2];
          var startedAt = performance.now();
          (function count(now) {
            var progress = Math.min(1, (now - startedAt) / 700);
            var eased = 1 - Math.pow(1 - progress, 3);
            offer.textContent = Math.round(target * eased) + '%' + suffix;
            if (progress < 1) window.requestAnimationFrame(count);
          })(startedAt);
        }
      }
    }

    function checkReveal() {
      if (!canvas || revealed) return;
      var context = canvas.getContext('2d');
      var pixels;
      try {
        pixels = context.getImageData(0, 0, canvas.width, canvas.height).data;
      } catch (error) {
        return;
      }
      var transparent = 0;
      var sampled = 0;
      for (var i = 3; i < pixels.length; i += 64) {
        sampled += 1;
        if (pixels[i] < 128) transparent += 1;
      }
      if (sampled > 0 && transparent / sampled > 0.45) revealPrize();
    }

    function revealPrize() {
      if (revealed) return;
      revealed = true;
      root.classList.add('is-revealed');
      canvas.style.transition = reduceMotion.matches ? 'none' : 'opacity 0.6s ease';
      canvas.style.opacity = '0';
      canvas.style.pointerEvents = 'none';
      if (hintCovered) hintCovered.hidden = true;
      if (hintRevealed) hintRevealed.hidden = false;
      if (dragHint) dragHint.style.display = 'none';
      markTagRevealed();
      celebrate();
    }

    function eraseAtEvent(event) {
      if (!canvas || revealed) return;
      var rect = canvas.getBoundingClientRect();
      if (!rect.width) return;
      var point = { x: event.clientX - rect.left, y: event.clientY - rect.top };
      var radius = desktop.matches ? 22 : 20;
      var context = canvas.getContext('2d');
      context.save();
      context.globalCompositeOperation = 'destination-out';
      var points = [];
      if (lastPoint) {
        var distance = Math.hypot(point.x - lastPoint.x, point.y - lastPoint.y);
        var steps = Math.max(1, Math.ceil(distance / (radius * 0.3)));
        for (var i = 1; i <= steps; i += 1) {
          var ratio = i / steps;
          points.push({
            x: lastPoint.x + (point.x - lastPoint.x) * ratio,
            y: lastPoint.y + (point.y - lastPoint.y) * ratio
          });
        }
      } else {
        points.push(point);
      }
      for (var j = 0; j < points.length; j += 1) {
        if (desktop.matches) {
          popStamp(context, points[j].x + (Math.random() - 0.5) * 5, points[j].y + (Math.random() - 0.5) * 5, radius * (0.8 + Math.random() * 0.34));
        } else {
          context.beginPath();
          context.arc(points[j].x, points[j].y, radius, 0, Math.PI * 2);
          context.fill();
        }
      }
      context.restore();
      lastPoint = point;
      addFlakes(point.x, point.y);
      eraseCount += points.length;
      if (eraseCount % 10 < points.length) checkReveal();
    }

    function resetScratch() {
      revealed = false;
      painted = false;
      drawing = false;
      eraseCount = 0;
      lastPoint = null;
      root.classList.remove('is-revealed');
      if (hintCovered) hintCovered.hidden = false;
      if (hintRevealed) hintRevealed.hidden = true;
      if (dragHint) dragHint.style.display = '';
      if (flakeLayer) flakeLayer.replaceChildren();
      window.requestAnimationFrame(function () { paintFoil(0); });
    }

    function setContentState(success) {
      if (defaultState) defaultState.hidden = !!success;
      if (successState) successState.hidden = !success;
      if (form) form.hidden = !!success;
    }

    function openPopup(options) {
      options = options || {};
      if (root.classList.contains('is-open')) return;
      previousFocus = document.activeElement;
      setContentState(!!options.success);
      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      lockPage();
      resetScratch();
      window.requestAnimationFrame(function () {
        root.classList.add('is-open');
        if (options.success) window.setTimeout(revealPrize, 80);
        var closeButton = query('[data-luma-scratch-close]', root);
        if (closeButton) window.setTimeout(function () { closeButton.focus({ preventScroll: true }); }, 50);
      });
    }

    function closePopup() {
      if (!root.classList.contains('is-open')) return;
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      unlockPage();
      window.setTimeout(function () {
        root.hidden = true;
        if (previousFocus && typeof previousFocus.focus === 'function') {
          try { previousFocus.focus({ preventScroll: true }); } catch (error) { previousFocus.focus(); }
        }
      }, reduceMotion.matches ? 0 : 420);
    }

    function openManual() {
      openPopup({ success: false });
    }

    function openAuto() {
      if (autoOpened || wasSeenRecently()) return;
      autoOpened = true;
      markSeen();
      openPopup({ success: false });
    }

    function paintTag(attempt) {
      if (!tagCanvas || !desktop.matches || tagWasRevealed()) return;
      var rect = tagCanvas.getBoundingClientRect();
      if (!rect.width || !rect.height) {
        if ((attempt || 0) < 20) window.requestAnimationFrame(function () { paintTag((attempt || 0) + 1); });
        return;
      }
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      tagCanvas.width = Math.round(rect.width * dpr);
      tagCanvas.height = Math.round(rect.height * dpr);
      var context = tagCanvas.getContext('2d');
      context.setTransform(dpr, 0, 0, dpr, 0, 0);
      context.clearRect(0, 0, rect.width, rect.height);
      goldFoil(context, rect.width, rect.height, 7.5);
    }

    function previewTagScratch() {
      if (!tagCanvas || !desktop.matches || tagWasRevealed() || reduceMotion.matches) return;
      var rect = tagCanvas.getBoundingClientRect();
      if (!rect.width) return;
      var context = tagCanvas.getContext('2d');
      context.save();
      context.globalCompositeOperation = 'destination-out';
      var total = 40;
      var startedAt = performance.now();
      var lastIndex = 0;
      (function step(now) {
        if (!tag.matches(':hover')) {
          context.restore();
          paintTag(0);
          return;
        }
        var progress = Math.min(1, (now - startedAt) / 560);
        var index = Math.min(total, Math.floor(progress * total));
        for (var i = lastIndex; i <= index; i += 1) {
          var ratio = i / total;
          var x = 8 + ratio * (rect.width - 16);
          var y = rect.height * 0.5 + Math.sin(ratio * Math.PI * 2.2) * (rect.height * 0.26);
          popStamp(context, x, y, 10);
        }
        lastIndex = index + 1;
        if (progress < 1) window.requestAnimationFrame(step);
        else context.restore();
      })(startedAt);
    }

    function copyCode() {
      if (!codeButton) return;
      var value = codeButton.getAttribute('data-code') || codeButton.textContent.trim();
      var copied = false;
      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        navigator.clipboard.writeText(value).catch(function () {});
        copied = true;
      }
      if (!copied) {
        var temporary = document.createElement('textarea');
        temporary.value = value;
        temporary.setAttribute('readonly', '');
        temporary.style.cssText = 'position:fixed;left:-9999px;top:0;';
        document.body.appendChild(temporary);
        temporary.select();
        try { document.execCommand('copy'); } catch (error) {}
        temporary.remove();
      }
      codeButton.textContent = 'COPIED!';
      window.setTimeout(function () { codeButton.textContent = value; }, 1200);
    }

    function cleanSuccessUrl() {
      if (!window.history || typeof window.history.replaceState !== 'function') return;
      try {
        var url = new URL(window.location.href);
        url.searchParams.delete('customer_posted');
        if (url.hash === '#lumaaura-scratch-newsletter') url.hash = '';
        window.history.replaceState({}, '', url.pathname + url.search + url.hash);
      } catch (error) {}
    }

    if (canvas) {
      canvas.addEventListener('pointerdown', function (event) {
        if (revealed) return;
        drawing = true;
        lastPoint = null;
        if (dragHint) dragHint.style.display = 'none';
        try { canvas.setPointerCapture(event.pointerId); } catch (error) {}
        eraseAtEvent(event);
        event.preventDefault();
      });
      canvas.addEventListener('pointermove', function (event) {
        if (!drawing) return;
        eraseAtEvent(event);
        event.preventDefault();
      });
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (eventName) {
        canvas.addEventListener(eventName, function () {
          if (!drawing) return;
          drawing = false;
          lastPoint = null;
          checkReveal();
        });
      });
    }

    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-luma-scratch-close]')) closePopup();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.classList.contains('is-open')) closePopup();
    });

    var manualOpen = query('[data-luma-scratch-open]');
    if (manualOpen) manualOpen.addEventListener('click', openManual);

    if (tag) {
      if (tagWasRevealed()) tag.classList.add('is-revealed');
      tag.addEventListener('click', openManual);
      tag.addEventListener('mouseenter', previewTagScratch);
      tag.addEventListener('mouseleave', function () { if (!tagWasRevealed()) paintTag(0); });
      paintTag(0);
    }

    if (codeButton) codeButton.addEventListener('click', copyCode);

    if (form) {
      form.addEventListener('submit', function () {
        var button = query('.luma-scratch__submit', form);
        if (button) {
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
        }
      });
    }

    function onBreakpointChange() {
      if (!revealed && root.classList.contains('is-open')) {
        painted = false;
        paintFoil(0);
      }
      paintTag(0);
    }

    if (desktop.addEventListener) desktop.addEventListener('change', onBreakpointChange);
    else if (desktop.addListener) desktop.addListener(onBreakpointChange);

    window.addEventListener('resize', function () {
      if (!revealed && root.classList.contains('is-open')) {
        painted = false;
        paintFoil(0);
      }
      paintTag(0);
    }, { passive: true });

    if (postedSuccess) {
      markSeen();
      cleanSuccessUrl();
      openPopup({ success: true });
    } else if (formError) {
      openPopup({ success: false });
    } else if (!(window.Shopify && window.Shopify.designMode) && !wasSeenRecently()) {
      window.setTimeout(openAuto, Math.max(delay, 0) * 1000);
      if (useExitIntent) {
        document.addEventListener('mouseout', function (event) {
          if (desktop.matches && event.clientY <= 0 && !event.relatedTarget) openAuto();
        });
      }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', boot);
})();
